import script from "./FormInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormInput.vue?vue&type=script&setup=true&lang=ts"

import "./FormInput.vue?vue&type=style&index=0&id=60692311&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60692311"]])

export default __exports__